// useRegions.ts
import { useMemo } from "react";
import  {allCountries} from "country-region-data";

export function useRegions(countryCode?: string) {
  return useMemo(() => {
    if (!countryCode) return [];
  
    const country = allCountries.find(
      (c) => c[1] === countryCode
    );

    if (!country) return [];

    return country[2].map((region) => ({
      value: region[1],  // e.g., "ON"
      label: region[0],       // e.g., "Ontario"
    }));
  }, [countryCode]);
}
